/*
 * Copyright 2021 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

import React from "react";
import {Route, Routes} from "react-router-dom";

import NotFound from "./containers/NotFound/NotFound";
import {Login} from "./containers/Login/Login";
import {EventList} from "./containers/Event/EventList";
import {ReplayList} from "./containers/Replay/ReplayList";
import {ReplayCreate} from "./containers/Replay/ReplayCreate";
import {UnauthenticatedRoute} from "./common/routes/UnauthenticatedRoute";
import {AuthenticatedRoute} from "./common/routes/AuthenticatedRoute";
import {SummaryView} from "./components/SummaryView/SummaryView";
import {EventView} from "./containers/Event/EventView";
import {ClipPreview} from "./containers/Event/ClipPreview";
import {HlsViewer} from "./containers/Replay/HlsViewer";
import { StorylineList } from "./containers/Storyline/StorylineList";

export default () => {
    return (
        <Routes>
            <Route path="/login" element={<UnauthenticatedRoute exact component={Login}/>}/>
            <Route path="/" element={<AuthenticatedRoute exact component={EventList}/>}/>
            <Route path="/home" element={<AuthenticatedRoute exact component={EventList}/>}/>
            <Route path="/listEvents" element={<AuthenticatedRoute exact component={EventList}/>}/>
            <Route path="/viewEvent" element={<AuthenticatedRoute exact component={EventView}/>}/>
            <Route path="/listReplays" element={<AuthenticatedRoute exact component={ReplayList}/>}/>
            <Route path="/viewReplay" element={<AuthenticatedRoute exact component={SummaryView}/>}/>
            <Route path="/addReplay" element={<AuthenticatedRoute exact component={ReplayCreate}/>}/>
            <Route path="/clipPreview" element={<AuthenticatedRoute exact component={ClipPreview}/>}/>
            <Route path="/hls" element={<AuthenticatedRoute exact component={HlsViewer}/>}/>
            <Route path="/listStorylines" element={<AuthenticatedRoute exact component={StorylineList}/>}/>

            { /* Finally, catch all unmatched routes */}
            <Route component={NotFound}/>
        </Routes>
    )
}
